import React from 'react';
import { ComponentTextXSmall } from '@modernhealth/vital-components';
import { colors } from '@modernhealth/vital-foundation';
import styled from '@emotion/styled';

import { FormattedDuration } from './FormattedDuration';

export const CircleOnDemandDuration: React.FC<{ seconds: number }> = ({ seconds }) => {
    return (
        <Container>
            <ComponentTextXSmall>
                <FormattedDuration seconds={seconds} />
            </ComponentTextXSmall>
        </Container>
    );
};

const Container = styled.div({
    position: 'absolute',
    bottom: 8,
    right: 8,
    backgroundColor: 'rgba(0,0,0,0.8)',
    color: colors.white,
    borderRadius: 4,
    padding: '6px 8px',
});
